const devConfig = {
  MASTER_TOKEN: "IrBS0xWt5rXItycGGO9X7iYyV5sM8zKo",
  IMAGEURL: "./assets/images/",
  API_BASE_URL: process.env.REACT_APP_API_URL,
};

export default devConfig;
